import { FC, HTMLProps } from 'react';

export const DocumentDownloadIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M9.99935 8.33333V13.3333M9.99935 13.3333L7.49935 10.8333M9.99935 13.3333L12.4993 10.8333M14.166 17.5H5.83268C4.91221 17.5 4.16602 16.7538 4.16602 15.8333V4.16667C4.16602 3.24619 4.91221 2.5 5.83268 2.5H10.4875C10.7085 2.5 10.9205 2.5878 11.0768 2.74408L15.5886 7.25592C15.7449 7.4122 15.8327 7.62416 15.8327 7.84518V15.8333C15.8327 16.7538 15.0865 17.5 14.166 17.5Z"
        stroke="#202020"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
